import "../App.css";
import { HashLink } from "react-router-hash-link";
// ----------------------------------------------------------------------

export default function WelcomePage() {
  return (
    <div className="welcomepage">
      <div className="welcome">
        <video
          src="https://rhood-api.onrender.com/videos/Butterflies.mp4"
          style={{
            width: "100%",
            height: "auto",
            position: "absolute",
            top: { xs: "0px", sm: "-390px" },
          }}
          autoPlay
          muted
          loop
        />
        <div className="img_animation">
          <img
            alt="loading"
            src="/assets/enter-text.png"
            style={{
              width: "220px",
              height: "220px",
              zIndex: 1,
              animation: "spin 12s linear infinite",
            }}
          />
        </div>
        <HashLink to="/about" style={{ position: "absolute", zIndex: 2 }}>
          <img
            alt="loading"
            src="/assets/enter-main.png"
            style={{ width: "150px", height: "150px" }}
          />
        </HashLink>
      </div>
    </div>
  );
}
